import React from "react";
import DepartmentHome from "../components/DepartmentHome.jsx";

const items = [
  ["Accounting", "/admin/accounting", "Income, expenses, and chart of accounts"],
  ["Billing Center", "/admin/billing", "Invoices, claims and payments received"],
  ["Reports", "/admin/reports", "Profit & Loss and other agency reports"],
];

const icons = {
  "Accounting": "📒",
  "Billing Center": "💳",
  "Reports": "📊",
};

export default function FinanceHome() {
  return (
    <DepartmentHome
      title="Finance & Revenue"
      description="Accounting, billing, and agency financial reports."
      items={items}
      icons={icons}
    />
  );
}
